// extracted by mini-css-extract-plugin
module.exports = {"transparentBtn":"IFad-"};